<template>
    <div class = "box-border-state">
        <div class = "boxContainer">
            <img src="/img/valueDeploymentState.svg">
            <p class ="emptyText">Your money is getting deployed in loans.</p>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        directToAllocation () {
            this.$emit('directToAllocation')
        }
    }

}
</script>

<style>
     .box-border-state {
        border-radius: 0px !important;
    }
    .boxContainer {
        margin-top: 10vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    .emptyText {
        padding-top: 16px;
        font-weight: 500;
        font-size: 12px;
        color: #9E9E9E;
    }
    .routeText {
        font-weight: 500;
        font-size: 12px;
        text-decoration-line: underline;
        color: #007AFF;
        cursor: pointer;
    }
</style>
